import React, {useEffect, useState} from 'react';
import ReactDOM from "react-dom";
import ReactTooltip from "react-tooltip";

const domNode = document.createElement('div');
document.body.appendChild(domNode);

function BodyPortal ({ children }) {
  return ReactDOM.createPortal(
    children,
    domNode
  );
}

const CustomReactTooltip = (props) => {
  useEffect(() => {
      ReactTooltip.rebuild();
  });

  return (
    <BodyPortal>
      <ReactTooltip
        anchorId="tooltip"
        {...props}
      />
    </BodyPortal>
  );
};

export default CustomReactTooltip;
